'use strict';

var blake2b = require('@noble/hashes/blake2b');
var base58 = require('bs58');
var y = require('yup');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

function _interopNamespaceCompat(e) {
  if (e && typeof e === 'object' && 'default' in e) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var base58__default = /*#__PURE__*/_interopDefaultCompat(base58);
var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

// Inspired by the implementation in smnt-client and PolkadotJS utils
// https://github.com/circlefin/smnt-client/blob/fb5899190409f6e4936a95e51c2e0524ff66af4f/smnt/src/main/java/com/circle/blockchain/account/smnt/keys/SubstrateAddress.java
// https://github.com/polkadot-js/common/blob/c08c947abfa00fd75302c8186cb939ef8bdd513a/packages/util-crypto/src/address/decode.ts
// 0 for Polkadot/Statemint, 42 for Westend/Westmint
const ALLOWED_PREFIXES = [
    0,
    42
];
// 32 or 33 byte public key + 2 byte checksum and 1 byte address prefix.
const ALLOWED_DECODED_LENGTHS = [
    35,
    36
];
const CHECKSUM_PREFIX = Uint8Array.from([
    83,
    83,
    53,
    56,
    80,
    82,
    69
]);
const name = 'statemint';
const STATEMINT_ERROR = 'statemint';
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? STATEMINT_ERROR
        },
        test: (value)=>{
            const address = Uint8Array.from(base58__default.default.decode(value));
            if (!ALLOWED_PREFIXES.includes(address[0])) {
                return false;
            }
            if (!ALLOWED_DECODED_LENGTHS.includes(address.length)) {
                return false;
            }
            const addressWithoutChecksum = address.subarray(0, address.length - 2);
            const checksumHash = blake2b.blake2b.create({}).update(CHECKSUM_PREFIX).update(addressWithoutChecksum).digest();
            return checksumHash[0] === address[address.length - 2] && checksumHash[1] === address[address.length - 1];
        }
    });
});

exports.STATEMINT_ERROR = STATEMINT_ERROR;
//# sourceMappingURL=statemint.js.map
